// What the POS catalogue last showed, kept for the rest of the session so the till can
// draw it instantly and refresh it quietly behind the cashier (owner, 2026-10-04).
//
// Before this, every return from checkout, every Products/Services switch and every chip
// tap went back to the server with an empty grid in between — the catalogue was fetched
// from scratch dozens of times a shift.
//
// IN MEMORY ONLY, never localStorage: prices and stock must not outlive the session, and a
// page reload is a deliberate "start fresh". Keys carry the outlet (or company), so another
// branch can never be shown this one's stock. Cleared at logout and whenever a sale moves
// stock (clearPosStock), so a stale badge is at most one quiet refresh old.

const tiles = new Map(); // `${outletId}|${catId}` -> { items, hasMore, pageNum }
const strips = new Map(); // outletId -> { categories, totalCount, uncategorizedCount }
const services = new Map(); // companyId -> services[]

const tileKey = (outletId, catId) => `${outletId}|${catId ?? "all"}`;

export const posCache = {
  getTiles: (outletId, catId) => tiles.get(tileKey(outletId, catId)),
  setTiles: (outletId, catId, entry) => tiles.set(tileKey(outletId, catId), entry),
  getStrip: (outletId) => strips.get(outletId),
  setStrip: (outletId, entry) => strips.set(outletId, entry),
  getServices: (companyId) => services.get(companyId),
  setServices: (companyId, list) => services.set(companyId, list),
};

// A sale, a return or an edit changed stock: the tile badges are no longer true. The
// strip and services carry no stock, so they stay.
export const clearPosStock = () => tiles.clear();

// Logout / session change: nothing of this session may be shown to the next.
export const clearPosCatalogCache = () => {
  tiles.clear();
  strips.clear();
  services.clear();
};
